<template>
  <div id="dialogCrearAdministrador">
    <v-dialog
      v-model="getCreateAdministradorDialog"
      persistent
      max-width="400px">
      <v-card>
        <v-card-title>Crear Nuevo Administrador</v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="formNewAdmin">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="nuevoAdminData.usuario"
                    label="Usuario administrador"
                    required
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="nuevoAdminData.adminType"
                    label="Tipo de Administrador"
                    required
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="nuevoAdminData.password"
                    label="Contraseña"
                    required
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="closeDialog">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="createAdministrador()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  data: function () {
    return {
      nuevoAdminData: {
        usuario: '',
        adminType: '',
        password: ''
      }
    };
  },

  computed: {
    ...mapGetters('admin', ['getCreateAdministradorDialog'])
  },

  methods: {
    async createAdministrador () {
      // console.log(this.nuevoAdminData)
      if (this.$refs.formNewAdmin.validate()) {
        let success = await this.fetchCreateAdmin(this.nuevoAdminData);
        if (success) {
          this.nuevoAdminData = {
            usuario: '',
            adminType: '',
            password: ''
          };
          await this.fetchListaAdministradores();
          this.closeDialog();
        }
      }
    },

    closeDialog () {
      this.setCreateAdministradorDialog(false);
    },

    ...mapMutations('admin', ['setCreateAdministradorDialog']),

    ...mapActions('admin', ['fetchCreateAdmin', 'fetchListaAdministradores'])
  }
};
</script>

<style>
</style>
